import { type KeyboardEvent, memo } from 'react';
import classNames from 'classnames';
import { Input } from '@devopsafs/react-ui-components';

import { Key } from 'src/constants';
import { useLocalization } from 'src/contexts/localization-context';
import useIsTablet from 'src/hooks/use-is-tablet';
import type { RangeProps } from './range.props';

import './range.scss';

const Range = ({
  className,
  endValue,
  maxValue,
  minValue,
  startValue,
  handleBlurMaxValue,
  handleBlurMinValue,
  setEndValue,
  setStartValue,
}: RangeProps) => {
  const { getLocalization } = useLocalization();
  const isTablet = useIsTablet();
  const inputSize = isTablet ? 'mini' : 'flattened';

  const handleInputEnterUp = (evt: KeyboardEvent<HTMLInputElement>) => {
    if (evt.key === Key.ENTER) {
      (evt.target as HTMLInputElement).blur();
    }
  };

  return (
    <div
      className={classNames('range', className)}
      role="menuitem"
      aria-label={getLocalization('Set range values')}
    >
      <Input
        className="range__input"
        inputMode="numeric"
        placeholder={minValue}
        size={inputSize}
        value={startValue}
        onBlur={handleBlurMinValue}
        onChange={setStartValue}
        onKeyUp={handleInputEnterUp}
      />
      <span className="range__divider" role="presentation">
        -
      </span>
      <Input
        className="range__input"
        inputMode="numeric"
        onBlur={handleBlurMaxValue}
        onChange={setEndValue}
        placeholder={maxValue}
        value={endValue}
        onKeyUp={handleInputEnterUp}
        size={inputSize}
      />
    </div>
  );
};

export default memo(Range);
